import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MasterService } from '../../../shared/services/master.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LoadingService } from '../../../shared/services/loading.service';

@Component({
	selector: 'app-token',
	imports: [],
	templateUrl: './token.component.html',
	styleUrl: './token.component.scss',
})
export class TokenComponent {
	activatedRoute = inject(ActivatedRoute);
	authService = inject(AuthService);
	router = inject(Router);
	masterService = inject(MasterService);
	loading = inject(LoadingService);

	constructor() {
		const token = this.activatedRoute.snapshot.params['tkn'];
		this.loading.show();
		this.authService.verifyToken(token).subscribe({
			next: (response: any) => {
				this.authService.setAccessToken(response.token);
				this.masterService.setMaster(null);
				this.masterService.setUser(null);
				this.router.navigate(['']);
			},
			error: (error: HttpErrorResponse) => {
				this.router.navigate(['login']);
			},
		});
	}
}
